import { useState, useEffect } from "react";

export function useLocalState(initialState: any) {
    const [state, setState] = useState(initialState);
    const updateState = (newState: any) => {
        setState((prevState: any) => {
            if (
                typeof prevState === 'object' &&
                prevState !== null &&
                typeof newState === 'object' &&
                newState !== null
            ) {
                return { ...prevState, ...newState };
            }
            return newState;
        });
    };
    return [state, updateState];
}

export function useDidMount(callBack: any) {
    useEffect(callBack, [callBack])
}